import {
  AbilityBuilder,
  CreateAbility,
  createMongoAbility,
  MongoAbility,
} from "@casl/ability";

const actions = [
  "create",
  "read",
  "update",
  "delete",
  "cancel",
  "approve",
  "sync",
  "upload",
  "void",
  "close",
  "print",
  "submit",
  "change-unit",
  "change-location",
  "end-contract",
] as const;
const subjects = [
  "accounting-account",
  "accounting-conversion",
  "accounting-currency",
  "accounting-tax",
  "accounting-type",
  "amortization",
  "ap-payment",
  "approver-purchase-requisition",
  "ar-aging-reminder",
  "asset-addition",
  "asset-adjustment",
  "asset-book",
  "asset-category",
  "asset-depreciation",
  "asset-reclass",
  "asset-retirement",
  "asset-transfer",
  "asset",
  "bank",
  "berita-acara",
  "branch-warehouse",
  "calendar",
  "cash-bank-movement",
  "cash-in-out",
  "cm-bank-transfer",
  "company",
  "contact-data",
  "contract-reminder",
  "delivery-order",
  "depreciation-report",
  "fifo-report",
  "general-journal",
  "input-pph",
  "internal-contract",
  "inventory-receive",
  "invoice-ap-prepayment",
  "invoice-ap",
  "invoice-ar",
  "invoice-controlling",
  "invoice-join",
  "invoice-overdue",
  "invoice-prepayment",
  "invoice-receipt",
  "leasing",
  "master-type",
  "menu",
  "payment-leasing",
  "picking-list",
  "preferences",
  "privilege",
  "product-category",
  "product-uom",
  "product",
  "purchase-order",
  "purchase-requisition",
  "report-aging",
  "report-kartu-hutang",
  "report-sales",
  "report-sales",
  "result-work-order",
  "return-to-supplier",
  "role",
  "sales-order",
  "sales-return",
  "sales-tracking",
  "settlement-bank",
  "spare-part-request-desktop",
  "stock-adjustment",
  "sync-company-bank",
  "tax-base-variable",
  "tax-income",
  "tax-invoice-code",
  "tax-invoice-sn",
  "tisn-reminder",
  "transfer-to-asset",
  "trucking-driver",
  "trucking-in-out",
  "trucking-invoice-ar",
  "trucking-payment",
  "trucking-rate",
  "trucking-sales-order",
  "trucking-settlement",
  "ujo-tracking",
  "unit-change-location",
  "unit-exchange",
  "unit-receipt-monitoring",
  "uom-conversion",
  "user",
  "warehouse-location",
  "warehouse-transfer",
  "warehouse",
  "work-order",
] as const;

export type Actions = (typeof actions)[number];
export type Subjects = (typeof subjects)[number];
export type AppAbilities = [Actions, Subjects];
export type MenuAccesses = `${Subjects}:${Actions}`;
export type AppAbility = MongoAbility<AppAbilities>;

export const createAppAbility = createMongoAbility as CreateAbility<AppAbility>;

export const defineUserPermissions = (
  authorities: MenuAccesses[]
): AppAbility => {
  const builder = new AbilityBuilder(createAppAbility);

  authorities.forEach(item => {
    const [menu, access] = item.split(/:/gm);
    builder.can(access.toLowerCase() as Actions, menu as Subjects);
  });
  return builder.build();
};
export const defaultAbility = defineUserPermissions([]);
